module.exports = __webpack_public_path__ + "static/img/Frame_4108@2x(3).21748cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4108@2x(3).png
// module id = /gNE
// module chunks = 64